import { Editor } from 'ckeditor5';
import { isCommentsOnlyMode } from './EditModeUtils';

export class ToolbarManager {
  private readonly toolbarWrapperElement;

  constructor(toolbarWrapperElement: HTMLElement) {
    this.toolbarWrapperElement = toolbarWrapperElement;
  }

  hideToolbar = (editor: Editor): void => {
    const toolbarElement = editor?.ui?.view?.toolbar?.element;
    if (toolbarElement) {
      toolbarElement.style.display = 'none';
    }
  };

  showToolbar = (editor: Editor): void => {
    const toolbarElement = editor?.ui?.view?.toolbar?.element;
    const toolbarWrapper = this.toolbarWrapperElement;
    if (toolbarElement && toolbarWrapper) {
      toolbarElement.style.display = 'flex';
    }
  };

  getEditorToolbarElement = (editor: Editor): HTMLElement => {
    const toolbarElement = editor?.ui?.view?.toolbar?.element;
    if (toolbarElement) {
      return toolbarElement;
    }
    throw new Error('could not obtain editor toolbar');
  };

  removeEditorToolbar = (toolbar: Element): void => {
    this.toolbarWrapperElement.removeChild(toolbar);
  };

  addEditorToolbar = (toolbarElement: Element): void => {
    const toolbarParentElementFirstChild =
      this.toolbarWrapperElement.firstChild;
    this.toolbarWrapperElement.insertBefore(
      toolbarElement,
      toolbarParentElementFirstChild,
    );
  };

  setToolbarFromEditor = (editor: Editor): void => {
    const existingToolbarElement =
      this.toolbarWrapperElement.querySelector('[role="toolbar"]');
    if (existingToolbarElement) {
      this.removeEditorToolbar(existingToolbarElement);
    }
    const toolbarElement = this.getEditorToolbarElement(editor);
    this.addEditorToolbar(toolbarElement);
    if (!isCommentsOnlyMode(editor) && !editor.isReadOnly) {
      this.showToolbar(editor);
    }
  };

  configureEditorToShowToolbarOnFocus = (editor: Editor): void => {
    editor.editing.view.document.on(
      'change:isFocused',
      (event: any, data: any, isFocused: boolean) => {
        if (isFocused) {
          this.setToolbarFromEditor(editor);
        }
      },
    );
  };
}
